

export type StorefrontConfigResponse = {
    content?: StorefrontConfigTokens;
    auth: StorefrontConfigAuth;
    theme?: StorefrontConfigTheme;
    shop: StorefrontConfigShop;
    customDomain?:StorefrontConfigCustomDomain;
  };
  
  export type StorefrontConfig = StorefrontConfigResponse;
  
  export type StorefrontConfigAuth = {
    region: string;
    userpoolId: string;
    identitypoolId: string;
    clientId: string;
    shopId: string;
  };

  export type StorefrontConfigCustomDomain = {
    domainName: string;
    shopId: string;
  };
  
  export type StorefrontConfigShop = {
    countryCode: string;
    /**
     * The shop's name, for screens that address the seller on its behalf (the
     * invitation says who invited them). Optional for the same reason as
     * currencyCode: a cached pre-deploy config renders once without it.
     */
    name?: string;
    /**
     * Shop currency (ISO 4217, e.g. "USD"). Optional: clients hydrated from a
     * cached pre-deploy config render once without it before the background
     * refetch fills it in — consumers must tolerate undefined.
     */
    currencyCode?: string;
    /**
     * Where a seller writes to the shop. The shop's Shopify contact address,
     * which every shop has.
     *
     * It lives here rather than on the partner API because the screens that
     * need it — the invitation, the sign-in trouble states, the updated-terms
     * screen — all render before there is anyone signed in to ask. Optional
     * for the same reason as the two above: a cached pre-deploy config renders
     * once without it.
     */
    contactEmail?: string;
  };

  export type StorefrontConfigTheme = {
    logoUrl?: string;
    faviconUrl?: string;
    primaryColor?: string;
    secondaryColor?: string;
    backgroundColor?: string;
    /** CSS length for the base corner-radius token, e.g. "8px". */
    radius?: string;
    /** Key into FONT_STACKS; unknown keys fall back to the built-in default. */
    fontFamily?: string;
    /** Monotonic counter bumped on every theme save. */
    themeVersion?: number;
  };

  /**
   * Curated web-safe font stacks for the theming editor. Keys are what gets
   * persisted on the shop theme; no font files are ever loaded.
   */
  export const FONT_STACKS = {
    system: "system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
    humanist: "Seravek, 'Gill Sans Nova', Ubuntu, Calibri, 'DejaVu Sans', source-sans-pro, sans-serif",
    geometric: "Avenir, Montserrat, Corbel, 'URW Gothic', source-sans-pro, sans-serif",
    serif: "'Iowan Old Style', 'Palatino Linotype', 'Book Antiqua', Palatino, Georgia, serif",
    mono: "ui-monospace, 'Cascadia Code', 'Source Code Pro', Menlo, Consolas, 'DejaVu Sans Mono', monospace",
  } as const;

  export type FontStackKey = keyof typeof FONT_STACKS;

  /**
   * Marker on postMessage payloads between the admin theming editor and the
   * partner app's /theme-preview iframe.
   */
  export const THEME_PREVIEW_MESSAGE_SOURCE = 'mppro-theming';
  
  export type StorefrontConfigTokens = {
    [key: string]: string;
  };
  
  export type StorefrontConfigError = {
    message: string;
  };